module.exports = "<h4>\n  {{title}}\n</h4>\n<p>\n  {{message}}\n</p>\n<button mat-raised-button (click)=\"dialogRef.close(true)\">OK</button>"


//////////////////
// WEBPACK FOOTER
// ./src/app/dialog-show/dialog-show.component.html
// module id = ./src/app/dialog-show/dialog-show.component.html
// module chunks = main